import React from 'react'
import { router } from './core/router/router'
import { useTheme } from './core/hooks/use-theme'
import { useUsuarioLogado } from './core/hooks/use-usuario-logado'
import { Loading } from './core/components/loading'
import { RouterProvider } from 'react-router-dom'

export const PrivateApp = () => {
  useTheme()
  const { usuarioLogado } = useUsuarioLogado()

  if (!usuarioLogado) {
    return <Loading />
  }

  return <RouterProvider router={router} />
}
